/** @var { UserState } */
const STATE = {
    data: null,
    // baseUrl: "http://localhost:8000/api/",
    // baseUrl: 'https://enigmatic-atoll-64574.herokuapp.com/api/',
    baseUrl: 'https://backend.ovexbroker.co.za/api/',
    token: null,
    user: null,
    isLoading: false,
    snackbarData: null,
    snackbarState: false,
};

export default STATE;
